import { Outlet } from "@tanstack/react-router";
import { BrandMark, Button, EmptyState, UpdateBar } from "@teamna/ui/components/index.ts";
import { useRoleTheme } from "@teamna/ui/hooks/use-role-theme.ts";

/** The document shell: the outlet, the 404 and the "new build" bar. Control Center is always in the admin colours. */
export function RootLayout() {
  useRoleTheme("admin");
  return (
    <>
      <Outlet />
      <UpdateBar />
    </>
  );
}

export function NotFoundScreen() {
  return (
    <div className="mx-auto flex min-h-dvh w-full max-w-app items-center px-5">
      <EmptyState
        title="Nothing here"
        message="That link does not lead anywhere in Control Center."
        action={<Button onClick={() => window.location.assign("/businesses")}>Go to businesses</Button>}
      />
    </div>
  );
}

export function SplashScreen({ label = "Loading" }: { label?: string }) {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-5">
      <BrandMark />
      <output
        className="size-5 animate-spin rounded-full border-2 border-line-strong border-t-accent"
        aria-label={label}
      />
    </div>
  );
}
